function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 29,
  stroke: "#4C9493",
  strokeLinecap: "round",
  strokeDasharray: "5 5"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30 53c12.703 0 23-10.297 23-23S42.703 7 30 7 7 17.297 7 30s10.297 23 23 23z",
  fill: "#4C9493"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.18 33.46l5.5-5.32.5-.5a4.64 4.64 0 00.46-.58c.147-.2.267-.407.36-.62.093-.227.14-.46.14-.7 0-.293-.06-.553-.18-.78a1.717 1.717 0 00-.44-.58 1.863 1.863 0 00-.66-.36 2.14 2.14 0 00-.78-.14c-.6 0-1.093.173-1.48.52-.387.347-.62.813-.7 1.4l-2.52-.2c.053-.653.207-1.227.46-1.72a3.968 3.968 0 011.02-1.26 4.373 4.373 0 011.44-.76 5.862 5.862 0 011.78-.26c.64 0 1.233.087 1.78.26.56.16 1.047.407 1.46.74.413.32.74.733.98 1.24s.36 1.1.36 1.78c0 .893-.207 1.667-.62 2.32-.4.64-.92 1.253-1.56 1.84l-4.38 4.06h6.56V36h-9.48v-2.54z",
  fill: "#fff"
});

var SvgStepItem2 = function SvgStepItem2(props) {
  return React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSIzMCIgY3k9IjMwIiByPSIyOSIgc3Ryb2tlPSIjNEM5NDkzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1kYXNoYXJyYXk9IjUgNSIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMzAgNTNjMTIuNzAzIDAgMjMtMTAuMjk3IDIzLTIzUzQyLjcwMyA3IDMwIDcgNyAxNy4yOTcgNyAzMHMxMC4yOTcgMjMgMjMgMjN6IiBmaWxsPSIjNEM5NDkzIi8+PHBhdGggZD0iTTI0LjE4IDMzLjQ2bDUuNS01LjMyLjUtLjVjLjE3My0uMTg3LjMyNy0uMzguNDYtLjU4LjE0Ny0uMi4yNjctLjQwNy4zNi0uNjIuMDkzLS4yMjcuMTQtLjQ2LjE0LS43IDAtLjI5My0uMDYtLjU1My0uMTgtLjc4YTEuNzE3IDEuNzE3IDAgMDAtLjQ0LS41OCAxLjg2MyAxLjg2MyAwIDAwLS42Ni0uMzZjLS4yNC0uMDkzLS41LS4xNC0uNzgtLjE0LS42IDAtMS4wOTMuMTczLTEuNDguNTItLjM4Ny4zNDctLjYyLjgxMy0uNyAxLjRsLTIuNTItLjJjLjA1My0uNjUzLjIwNy0xLjIyNy40Ni0xLjcyYTMuOTY4IDMuOTY4IDAgMDExLjAyLTEuMjYgNC4zNzMgNC4zNzMgMCAwMTEuNDQtLjc2IDUuODYyIDUuODYyIDAgMDExLjc4LS4yNmMuNjQgMCAxLjIzMy4wODcgMS43OC4yNi41Ni4xNiAxLjA0Ny40MDcgMS40Ni43NC40MTMuMzIuNzQuNzMzLjk4IDEuMjRzLjM2IDEuMS4zNiAxLjc4YzAgLjg5My0uMjA3IDEuNjY3LS42MiAyLjMyLS40LjY0LS45MiAxLjI1My0xLjU2IDEuODRsLTQuMzggNC4wNmg2LjU2VjM2aC05LjQ4di0yLjU0eiIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg==";
export { SvgStepItem2 as ReactComponent };